import React, { useState, useEffect } from "react";
import "./App.css";

function App() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [language, setLanguage] = useState("en");

  const translations = {
    de: {
      home: "Home",
      about: "Über mich",
      skills: "Skills",
      projects: "Projekte",
      contact: "Kontakt",
      heroTitle: "Hallo, ich bin",
      heroDesc:
        "Leidenschaftlicher Software-Entwickler mit Fokus auf moderne Webtechnologien und innovative Lösungen. Ich verwandle Ideen in digitale Realität.",
      ctaProjects: "Projekte ansehen",
      ctaContact: "Kontakt aufnehmen",
      aboutTitle: "Über mich",
      aboutDesc:
        "Erfahrener Software-Entwickler mit einer Leidenschaft für sauberen Code und innovative Technologien. Ich arbeite gerne in agilen Teams und bin immer auf der Suche nach neuen Herausforderungen.",
      skillsTitle: "Technische Skills",
      skillsDesc:
        "Moderne Technologien und bewährte Praktiken für erstklassige Softwareentwicklung",
      projectsTitle: "Meine Projekte",
      projectsDesc: "Eine Auswahl meiner aktuellen Arbeiten und Projekte",
      contactTitle: "Kontakt aufnehmen",
      contactDesc: "Lassen Sie uns über Ihr nächstes Projekt sprechen",
      footer: "© 2024 Hasan Al Mohamad. Alle Rechte vorbehalten.",
      skillList: [
        "JavaScript",
        "React",
        "Node.js",
        "CSS",
        "HTML",
        "MongoDB",
        "TypeScript",
        "Next.js",
        "Express.js",
        "REST APIs",
        "Git & GitHub",
        "Tailwind CSS",
        "Bootstrap",
        "MySQL",
        "Figma",
      ],
      projectList: [
        {
          title: "Portfolio Website",
          desc: "Meine persönliche Portfolio-Website mit React.",
        },
        {
          title: "E-Commerce App",
          desc: "Eine moderne E-Commerce-Anwendung mit Node.js.",
        },
      ],
      formName: "Name",
      formEmail: "E-Mail",
      formMessage: "Nachricht",
      formSend: "Senden",
      langButton: "English",
      dir: "ltr",
    },
    en: {
      home: "Home",
      about: "About me",
      skills: "Skills",
      projects: "Projects",
      contact: "Contact",
      heroTitle: "Hello, I am",
      heroDesc:
        "Passionate software developer focusing on modern web technologies and innovative solutions. I turn ideas into digital reality.",
      ctaProjects: "View Projects",
      ctaContact: "Get in Touch",
      aboutTitle: "About Me",
      aboutDesc:
        "Experienced software developer with a passion for clean code and innovative technologies. I enjoy working in agile teams and always seek new challenges.",
      skillsTitle: "Technical Skills",
      skillsDesc:
        "Modern technologies and best practices for top-notch software development",
      projectsTitle: "My Projects",
      projectsDesc: "A selection of my current works and projects",
      contactTitle: "Get in Touch",
      contactDesc: "Let's talk about your next project",
      footer: "© 2024 Hasan Al Mohamad. All rights reserved.",
      skillList: [
        "JavaScript",
        "React",
        "Node.js",
        "CSS",
        "HTML",
        "MongoDB",
        "TypeScript",
        "Next.js",
        "Express.js",
        "REST APIs",
        "Git & GitHub",
        "Tailwind CSS",
        "Bootstrap",
        "MySQL",
        "Figma",
      ],
      projectList: [
        {
          title: "Portfolio Website",
          desc: "My personal portfolio website built with React.",
        },
        {
          title: "E-Commerce App",
          desc: "A modern e-commerce application with Node.js.",
        },
      ],
      formName: "Name",
      formEmail: "Email",
      formMessage: "Message",
      formSend: "Send",
      langButton: "العربية",
      dir: "ltr",
    },
    ar: {
      home: "الرئيسية",
      about: "نبذة عني",
      skills: "المهارات",
      projects: "المشاريع",
      contact: "اتصل بي",
      heroTitle: "مرحباً، أنا",
      heroDesc:
        "مطور برامج مفعم بالشغف يركز على تقنيات الويب الحديثة والحلول المبتكرة. أحول الأفكار إلى واقع رقمي.",
      ctaProjects: "عرض المشاريع",
      ctaContact: "تواصل معي",
      aboutTitle: "نبذة عني",
      aboutDesc:
        "مطور برامج ذو خبرة وشغف بالكتابة النظيفة والتقنيات المبتكرة. أستمتع بالعمل في فرق مرنة وأسعى دائمًا لتحديات جديدة.",
      skillsTitle: "المهارات التقنية",
      skillsDesc: "تقنيات حديثة وممارسات موثوقة لتطوير برامج عالية الجودة",
      projectsTitle: "مشاريعي",
      projectsDesc: "مجموعة من أعمالي ومشاريعي الحالية",
      contactTitle: "تواصل معي",
      contactDesc: "دعنا نتحدث عن مشروعك القادم",
      footer: "© 2024 حسن المحمد. كل الحقوق محفوظة.",
      skillList: [
        "جافاسكربت",
        "ريأكت",
        "نود.جي إس",
        "سي إس إس",
        "إتش تي إم إل",
        "مونغو دي بي",
        "تايب سكريبت",
        "نكست.جي إس",
        "إكسبريس.جي إس",
        "واجهات برمجة REST",
        "جيت و GitHub",
        "Tailwind CSS",
        "بوتستراب",
        "MySQL",
        "فيجما",
      ],
      projectList: [
        {
          title: "موقع بورتفوليو",
          desc: "موقعي الشخصي المبني باستخدام ريأكت.",
        },
        {
          title: "تطبيق التجارة الإلكترونية",
          desc: "تطبيق تجارة إلكترونية حديث باستخدام نود.جي إس.",
        },
      ],
      formName: "الاسم",
      formEmail: "البريد الإلكتروني",
      formMessage: "الرسالة",
      formSend: "إرسال",
      langButton: "Deutsch",
      dir: "rtl",
    },
  };

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    document.documentElement.dir = translations[language].dir;
  }, [language]);

  const scrollToSection = (sectionId) => {
    document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth" });
  };

  const toggleLanguage = () => {
    if (language === "de") setLanguage("en");
    else if (language === "en") setLanguage("ar");
    else setLanguage("de");
  };

  const t = translations[language];

  return (
    <div className="App">
      {/* Photo at the top */}

      <div className="top-photo">
        <img src="/me.png" alt="Profile" />
      </div>

      <nav className={`navbar ${isScrolled ? "scrolled" : ""}`}>
        <div className="nav-container">
          <div className="logo code-font">{"<Dev/>"}</div>
          <ul className="nav-menu">
            {["home", "about", "skills", "projects", "contact"].map((key) => (
              <li key={key}>
                <a onClick={() => scrollToSection(key)} className="nav-link">
                  {t[key]}
                </a>
              </li>
            ))}
          </ul>
          <button onClick={toggleLanguage} className="btn btn-secondary">
            {t.langButton}
          </button>
        </div>
      </nav>

      {/* Hero Section */}
      <section id="home" className="hero">
        <div className="hero-container">
          <div className="hero-content">
            <div className="logo code-font1">{"<Dev/>"}</div>
            <h1>
              {t.heroTitle}{" "}
              <span className="gradient-text">Hasan Al Mohamad</span>
            </h1>
            <p>{t.heroDesc}</p>

            <div className="cta-buttons">
              <a
                onClick={() => scrollToSection("projects")}
                className="btn btn-primary"
              >
                {t.ctaProjects}
              </a>
              <a
                onClick={() => scrollToSection("contact")}
                className="btn btn-secondary"
              >
                {t.ctaContact}
              </a>
              <a
                href="https://wa.me/963995452834"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-whatsapp"
              >
                💬 WhatsApp
              </a>
            </div>

            {/* Language button shown only on mobile */}
            <button
              onClick={toggleLanguage}
              className="btn btn-secondary hero-lang-btn"
            >
              {t.langButton}
            </button>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="section">
        <div className="container">
          <div className="section-title">
            <h2>{t.aboutTitle}</h2>
            <p>{t.aboutDesc}</p>

            {/* Download CV Button */}
            <a
              href="/Hasan_Al_Mohamad_CV.pdf" // Path to your CV file in public folder
              download
              className="btn btn-primary download-cv"
            >
              📄 Download CV
            </a>
          </div>
        </div>
      </section>

      {/* Skills Section */}
      <section id="skills" className="section">
        <div className="container">
          <div className="section-title">
            <h2>{t.skillsTitle}</h2>
            <p>{t.skillsDesc}</p>
          </div>
          <ul className="skills-list">
            {t.skillList.map((skill, i) => (
              <li key={i}>{skill}</li>
            ))}
          </ul>
        </div>
      </section>

      {/* Projects Section */}
      <section id="projects" className="section">
        <div className="container">
          <div className="section-title">
            <h2>{t.projectsTitle}</h2>
            <p>{t.projectsDesc}</p>
          </div>
          <div className="projects-grid">
            {t.projectList.map((proj, i) => (
              <div className="project-card" key={i}>
                <h3>{proj.title}</h3>
                <p>{proj.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      {/* Contact Section */}
      <section id="contact" className="section contact">
        <div className="container">
          <div className="section-title">
            <h2>{t.contactTitle}</h2>
            <p>{t.contactDesc}</p>

            {/* Email as clickable sender */}
            <p className="contact-email">
              📧 E-Mail an:{" "}
              <a href="mailto:Hasan.almohamad95@gmail.com">
                Hasan.almohamad95@gmail.com
              </a>
            </p>
            <p className="contact-phone">
              📞 Telefon: <a href="tel:+963995452824">00963 995 452 834</a>
            </p>
          </div>

          <form
            className="contact-form"
            action="mailto:Hasan.almohamad95@gmail.com"
            method="POST"
            encType="text/plain"
          >
            <label>{t.formName}</label>
            <input type="text" name="name" placeholder={t.formName} />

            <label>{t.formEmail}</label>
            <input type="email" name="email" placeholder={t.formEmail} />

            <label>{t.formMessage}</label>
            <textarea name="message" placeholder={t.formMessage}></textarea>

            <button type="submit" className="btn btn-primary">
              {t.formSend}
            </button>
          </form>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <p>{t.footer}</p>
          <p className="footer-address">📍 Syria, Manbij</p>
        </div>
      </footer>
    </div>
  );
}

export default App;
